import { render, staticRenderFns } from "./AppPaginaTitulo.vue?vue&type=template&id=1f88b92a&"
import script from "./AppPaginaTitulo.vue?vue&type=script&lang=js&"
export * from "./AppPaginaTitulo.vue?vue&type=script&lang=js&"
import style0 from "./AppPaginaTitulo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports